import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "name", "TypographyProps"];
import React from 'react';
import Typography from "antd/es/typography/index.js";
import PropTypes from 'prop-types';
var Paragraph = Typography.Paragraph;

var PlainText = function PlainText(_ref) {
  var label = _ref.label,
      name = _ref.name,
      TypographyProps = _ref.TypographyProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Typography, TypographyProps, label.split('\n').map(function (paragraph, index) {
    return /*#__PURE__*/React.createElement(Paragraph, _extends({
      key: "".concat(index, "-").concat(name)
    }, rest), paragraph);
  }));
};

PlainText.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  TypographyProps: PropTypes.object
};
export default PlainText;